import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { OnboardingPageService } from '../onboarding-page/onboarding-page.service';

@Component({
  selector: 'app-verification-status',
  template: require('./verification-status.component.html')
})
export class VerificationStatusComponent implements OnInit {

  constructor(private _onboardingService: OnboardingPageService) { }
  public verificationResponse : Object;
  public verificationStatus : String = "N/A";
  public showSpinner: Boolean = false;
  @Input() riderId: String;
  @Input() docType: String;
  @Input() asyncRefreshTrigger: Observable<void>;

  @Output() verificationUpdate: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    // Don't auto-load on init - only load when verify button is clicked
    this.asyncRefreshTrigger.subscribe(() => {
      this.showSpinner = true;
      setTimeout(() => this.onAsyncRefreshTrigger(), 100);
    });
  }

  onAsyncRefreshTrigger() {
    this.showSpinner = true;
    this._onboardingService.getDocVerificationStatus(this.riderId,this.docType).subscribe(response => {
      if (response && response['status']) {
        this.verificationResponse = response;
        this.verificationStatus = response['status'];
        this.verificationUpdate.emit(this.verificationResponse);
        if(this.verificationStatus === 'In Progress') {
          setTimeout(() => {this.onAsyncRefreshTrigger()}, 5000);
        } else {
          this.showSpinner = false;
        }
      } else {
        // If no status or response, stop spinner
        this.showSpinner = false;
        this.verificationStatus = 'N/A';
      }
    },err => {
      this.showSpinner = false;
      this.verificationStatus = 'N/A';
      console.error(err);
    });
  }
}
